import { HttpParams } from '@angular/common/http'
import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { CellEditEndingEventArgs, FlexGrid } from '@grapecity/wijmo.grid'
import { QuillViewComponent } from 'ngx-quill'

import { BaseComponent, FeatureType, Grid, ModalSize, Notification, User } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { NotificationComponent } from './notification.component'

@Component({
    selector: 'app-notification-templates',
    templateUrl: './notification-templates.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
        QuillViewComponent,
    ],
})
export class NotificationTemplatesComponent extends BaseComponent {
    faSearch = faSearch
    grid: Grid<Notification>
    usersGrid: Grid<User>

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.HrNotificationEdit])
    }

    constructor() {
        super()
        this.grid = new Grid<Notification>(this.services)
            .setupModalEditing(
                this.services.data.notifications,
                'Notification',
                NotificationComponent,
                () => new Notification(),
                this,
                ModalSize.large,
            )
            .wrapColumnHeaders()
            .filterBy(item => [item.title, item.body])

        this.usersGrid = new Grid<User>(this.services)
            .wrapColumnHeaders()
            .filterBy(item => [item.displayName])
            .isReadOnly(false)

        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(true, true, this.services.data.notifications.queryAll(), this.services.data.groups.queryAll())
                .subscribe({
                    next: result => {
                        this.grid.items = result[0]
                    },
                }),
        )
    }

    getUsersforGroups() {
        if (!this.grid.selectedItem) return
        const params = new HttpParams().append('includeHasToken', true)
        this.cancelableRequest(
            'GetGroupUsers',
            true,
            this.services.data
                .load(true, true, this.services.data.post('api/Group/GetGroupUsers', this.grid.selectedItem.groupIds, params))
                .subscribe({
                    next: result => {
                        const users = result[0] as User[]
                        this.usersGrid.items = users
                    },
                }),
        )
    }

    send(item: Notification) {
        const params = new HttpParams().append('id', item.id)
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.get('/api/Notification/SendNotification', params)).subscribe({
                next: () => {
                    this.services.notification.success('Notifications Sent!')
                },
            }),
        )
    }

    getRecipientsCellValue({ item }: { item: Notification }) {
        return item.groupIds.map(groupId => this.services.data.groups.items.find(group => group.id === groupId)?.name).join(', ')
    }

    cellBeginningEdit(flexGrid: FlexGrid, args: CellEditEndingEventArgs) {
        args.cancel = true
    }
}
